module.exports = __webpack_public_path__ + "img/gmv.2e3a2058.svg";